import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ConfirmDialog } from "../ConfirmDialog";
import { BULK } from "../bulkActions";
import { useAuth } from "../../../context/AuthContext";
import { canDo, setStatus, setFeatured } from "../../../lib/adminApi";

const btn = "rounded-full px-3 py-1.5 text-xs font-semibold transition-colors";
const primary = `${btn} bg-[#7A0016] text-[#F5E6BA] hover:bg-[#4A000E]`;
const outline = `${btn} border border-[#D4AF37]/70 bg-white text-[#7A0016] hover:bg-[#F5E6BA]/50`;

export function ProfileActions({ profile, onChanged }) {
  const auth = useAuth();
  const navigate = useNavigate();
  const [action, setAction] = useState(null);
  const ask = (a, after) => setAction({
    ...a.confirm(1),
    confirmLabel: a.label,
    run: async (reason) => {
      try { await a.run([profile.id], reason); toast.success(`${a.label} done`); after ? after() : onChanged(); } catch (e) { toast.error(e.message); }
    },
  });
  const simple = (label, status, description) => ({
    id: status, label, confirm: () => ({ title: `${label} this profile?`, description }), run: (ids) => setStatus(ids, status),
  });
  const toggleFeatured = async () => {
    try { await setFeatured(profile.id, !profile.is_featured); toast.success(profile.is_featured ? "Removed from featured" : "Marked as featured"); onChanged(); } catch (e) { toast.error(e.message); }
  };
  const s = profile.status;
  return (
    <div className="flex flex-wrap gap-2" data-testid="profile-actions">
      {canDo(auth, "can_approve") && (
        <>
          {s !== "approved" && s !== "blocked" && <button type="button" className={primary} onClick={() => ask(BULK.approve)} data-testid="action-approve">Approve</button>}
          {s !== "rejected" && <button type="button" className={outline} onClick={() => ask(BULK.reject)} data-testid="action-reject">Reject</button>}
          {s !== "hold" && <button type="button" className={outline} onClick={() => ask(BULK.hold)} data-testid="action-hold">Hold</button>}
          {s === "blocked" ? (
            <button type="button" className={outline} onClick={() => ask(simple("Unblock", "approved", "The client regains access and the profile becomes approved."))} data-testid="action-unblock">Unblock</button>
          ) : (
            <button type="button" className={outline} onClick={() => ask(BULK.block)} data-testid="action-block">Block</button>
          )}
          {s !== "inactive" && <button type="button" className={outline} onClick={() => ask(simple("Deactivate", "inactive", "The profile is hidden and the client account is disabled."))} data-testid="action-deactivate">Deactivate</button>}
        </>
      )}
      {(canDo(auth, "can_share") || canDo(auth, "can_edit")) && (
        <button type="button" className={outline} onClick={toggleFeatured} data-testid="action-featured">{profile.is_featured ? "Unfeature" : "Mark featured"}</button>
      )}
      {canDo(auth, "can_edit") && (
        <button type="button" className={`${btn} bg-[#A31828] text-white hover:bg-[#7A0016]`} onClick={() => ask(BULK.delete, () => navigate("/admin/profiles", { replace: true }))} data-testid="action-delete">Delete</button>
      )}
      <ConfirmDialog action={action} onClose={() => setAction(null)} />
    </div>
  );
}
